import { Component, OnInit, Renderer2, ViewChild, ElementRef, Input } from '@angular/core';
import { faTimes} from '@fortawesome/pro-light-svg-icons';
import { CorrespondenceTimelineService } from '../../../../shared/services/correspondence-timeline.service';
import { InvoiceService } from '../../../../shared/services/invoice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-invoice-uploader',
  templateUrl: './invoice-uploader.component.html',
  styleUrls: ['./invoice-uploader.component.scss']
})
export class InvoiceUploaderComponent implements OnInit {

  @Input() caseId: number;

  files : any = [];
  uploadingInvoice: boolean = false;
  faTimes= faTimes;
  feeTypes: any = [];
  feeType: any;
  hasError: boolean = false;
  errorMessage: string = "";

  @ViewChild('innerContent') innerContent: ElementRef | undefined;

  constructor(
  private renderer: Renderer2,
  private invoiceService: InvoiceService,
  private correspondenceTimelineService: CorrespondenceTimelineService,
  public activeModal: NgbActiveModal) { 

  }

  ngOnInit(): void {
    this.invoiceService.getFeeTypesWithSuppliers().subscribe((response : any) => {
      this.feeTypes = response.feeTypes;
    });
  }

  dragOver(event: any) {
    event.preventDefault();
    event.stopPropagation();
    //this.renderer.setStyle(this.innerContent?.nativeElement, 'pointer-events', 'none');
  }

  dragLeave(event: any) {
    event.preventDefault();
    event.stopPropagation();
  }

  dragDropOLD(event: any) {
    event.preventDefault();
    event.stopPropagation();    

    let files = event.dataTransfer.files;

    if (files.length > 0) {      
      for (var i = 0; i < files.length; i++) {
        var fileName = files[i].name;  
        this.files.push({
          fileName: fileName,
          file: files[i],
          uploading: false,
          success: false,
          error: null
        });
      }
    }

  }

  dragDrop(event: any) {
    event.preventDefault();
    event.stopPropagation();    

    let files = event.dataTransfer.files;

    // We only want to allow one file at a time - if multiple are dragged - get first one

    if (files.length > 0) {      
        var fileName = files[0].name;  
        this.files.push({
          fileName: fileName,
          file: files[0],
          uploading: false,
          success: false,
          error: null
        });
    }
  }

  removeFile (index:number) {
    this.files.splice(index, 1);
  }

  uploadInvoice(){
    this.uploadingInvoice = true;
    this.invoiceService.uploadInvoice(this.caseId, this.files[0].file, this.feeType).subscribe((response : any) => {
      this.correspondenceTimelineService.refreshCaseTimeline.next();
      this.activeModal.close(true);
    }, (error : any) => {
      this.hasError = true;
      this.errorMessage = error.error;
    });
  }

  /*
  uploadFile(file: any): Promise<boolean>{

    return new Promise<boolean>((resolve, reject) => {

    this.invoiceService.uploadInvoice(this.caseId, file ).subscribe((response : any) => {
      this.correspondenceTimelineService.refreshCaseTimeline.next();
      resolve(true);

    }, (error : any) => {

      resolve(false);

    });

  });

  }
  */

}


